import { createAction } from 'typesafe-actions'

import { Report, ReportsActionTypes, ReportsResourcesAvailable } from './types'

export const getReports = createAction(
  ReportsActionTypes.GET_REPORTS,
  action => (report_id?: string) => action({ report_id })
)

export const getReportsFailure = createAction(
  ReportsActionTypes.GET_REPORTS_FAILURE,
  action => () => action()
)

export const getReportsSuccess = createAction(
  ReportsActionTypes.GET_REPORTS_SUCCESS,
  action => (reports: Report[]) => action({ reports })
)

export const getReportsResource = createAction(
  ReportsActionTypes.GET_REPORTS_RESOURCE,
  action => (resource: keyof ReportsResourcesAvailable, query_string: string) =>
    action({ resource, query_string })
)

export const getReportsResourceFailure = createAction(
  ReportsActionTypes.GET_REPORTS_RESOURCE_FAILURE,
  action => (resource: keyof ReportsResourcesAvailable) => action({ resource })
)

export const getReportsResourceSuccess = createAction(
  ReportsActionTypes.GET_REPORTS_RESOURCE_SUCCESS,
  action =>
    <K extends keyof ReportsResourcesAvailable>(
      resource: keyof ReportsResourcesAvailable,
      data: ReportsResourcesAvailable[K][]
    ) =>
      action({ resource, data })
)

export const resetResources = createAction(
  ReportsActionTypes.RESOURCE_RESET,
  action => () => action()
)
